export default "__VITE_ASSET__d42e9280__"